<template>
  <div class="l-main">
    <div class="c-imgarena__component">
      <md-tabs
        class="c-tabs c-tabs--medium c-imgarena__sidebar"
        :md-active-tab="selectedTab.key"
      >
        <md-tab
          v-for="subsection in availableSubsections"
          :id="subsection.key"
          :key="subsection.key"
          :md-label="subsection.name"
          @click="changeSubsection(subsection)"
        />
      </md-tabs>

      <div class="l-main__ctn u-overflow-auto">
        <component :is="selectedTab.component" />
      </div>
    </div>
  </div>
</template>

<script>

import {PERMISSION_NAMES} from "@/const/online-permissions";
import {onlinePermissionsMixin} from "@/mixins/onlinePermissionsMixin";
import {validationBaseMixin} from '@/mixins/ValidationBaseMixin';
import ImgArenaPairs from "@/pages/on-line/configurations/components/img-arena/img-arena-pairs/index.vue";
import InfrontPairs from "@/pages/on-line/configurations/components/img-arena/infront-pairs/index.vue";
import StreamConfig from "@/pages/on-line/configurations/components/img-arena/stream-config/index.vue";

export default {
  name: "ImgArenaConfiguration",

  components: {
    ImgArenaPairs,
    InfrontPairs,
    StreamConfig,
  },

  mixins: [onlinePermissionsMixin, validationBaseMixin],

  data() {
    return {
      selectedTab: {
        name: 'imgarena pairs',
        key: 'imgarena-pairs',
        component: 'ImgArenaPairs',
      },
      availableSubsections: [
        {
          name: 'configuration',
          key: 'configuration',
          component: 'StreamConfig',
        },
        {
          name: 'imgarena pairs',
          key: 'imgarena-pairs',
          component: 'ImgArenaPairs',
        },
        {
          name: 'infront pairs',
          key: 'infront-pairs',
          component: 'InfrontPairs',
        }
      ],
    }
  },

  computed: {
    PERMISSION_NAMES() {
      return PERMISSION_NAMES
    },
  },

  methods: {
    changeSubsection(subsection) {
      this.selectedTab = subsection
    }
  }
};
</script>

<style lang="scss" scoped>
.c-imgarena__component {
  display: flex;
  flex: 1;
  max-height: 100%;
}

.c-imgarena__sidebar {
  max-width: 200px;
}

.c-modal-body--search {
  padding: 0 16px;
}

.sports-wrapper {
  padding: 16px;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: stretch;
  gap: 10px;
  margin-bottom: 10px;

  button {
    min-width: auto;
    padding: 5px 5px;
    flex-grow: 1;
    max-width: 200px;
  }
}

</style>
<script setup>
</script>
